var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block-type-8 block-type-8--with-color-block"},[_c('div',{staticClass:"block-type-8__content display-flex justify-content-between"},[_c('h4',{staticClass:"block-type-8__title"},[_vm._v("Aktualu")]),_c('div',{staticClass:"block-type-8__color-block",staticStyle:{"background":"#3858f5"}})])])
}]

export { render, staticRenderFns }